enum CompetitiveInsightsViewTypeEnum {
  NetworkView = "Network View",
  MapView = "Map View",
}

export { CompetitiveInsightsViewTypeEnum };
